import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Dialog from "../dialog";

class NoMatch extends Component {

    render() {
        const body =
            <div className="NoMatch">
                <p>{'Stránka, kterou hledáte neexistuje. Nevadí, pomůžeme vám se znovu najít.'}</p>
                <Link to={`${process.env.PUBLIC_URL}/${this.props.match.params.hash}`} className='Btn'>{'Přejít na hodnocení'}</Link>
            </div>;

        return (
            <div className="QuestionForm QuestionForm--center">
                <div className="QuestionForm__body QuestionForm__body--center">
                  <Dialog title={'Ztratili jste se v myšlenkách?'} body={body}/>
                </div>
            </div>
        );
    }

}


export default NoMatch;


// WEBPACK FOOTER //
// ./src/components/noMatch/index.js